const date = new Date();
const year = date.getFullYear();
const isPOS = window.location.href.toLowerCase().includes("karlstechnology");
const isFFLBoss = window.location.href.toLowerCase().includes("fflboss");
const isTactical = window.location.hostname.toLowerCase().endsWith("tacticalpos.com");
window.isTacticalPay = window.location.hostname.toLowerCase().endsWith("tacticalpay.com");
const isTacticalPay = window.isTacticalPay;
const isePOS = window.location.href.toLowerCase().includes("cloud");
const isAmmoReady = window.location.href.toLowerCase().includes("ammoready");

const APPCONFIG = {
	brand: (() => {
		const title =
			isTacticalPay ? "TacticalPay POS" :
				(isTactical ? "Tactical POS" :
					(isePOS ? 'ePOS Cloud' :
						((isFFLBoss || isPOS) ? 'FFL Boss POS' :
							(isAmmoReady ? 'AmmoReady POS' :
							'POS'))));
		document.title = title;
		return title;
	})(),
	boldCount:
		isTacticalPay ? 1 :
			(isTactical ? 1 :
				(isePOS ? 1 :
					((isFFLBoss || isPOS) ? 2 :
						(isAmmoReady ? 1 :
						0)))),
	year,
	copyright: '2018',
	productLink: isTacticalPay ? "https://pos.tacticalpay.com" : 'https://pos.karlstechnology.com',
		settings: {
			tacticalConnectedAccountId: () => {
				return APPCONFIG.settings.isDev() ? 'acct_1Na3u2PAM4AUj9XU' : 'acct_1TJzLbAFon8MTXbw';
			},
			isDev: () => {
			if(isPOS || isFFLBoss){
				return window.location.hostname === 'dev.pos.karlstechnology.com' || window.location.hostname === 'beta.pos.karlstechnology.com';
			} else if (isTactical){
				return window.location.hostname === 'dev.tacticalpos.com' || window.location.hostname === 'beta.tacticalpos.com';
			} else if (isePOS){
				return window.location.hostname === 'dev.eposcloud.net' || window.location.hostname === 'beta.eposcloud.net';
			} else if (isTacticalPay){
				return window.location.hostname === 'dev.pos.tacticalpay.com' || window.location.hostname === 'beta.pos.tacticalpay.com';
			} else if (isAmmoReady){
				return window.location.hostname === 'dev.pos.ammoready.com' || window.location.hostname === 'beta.pos.ammoready.com';
			}
		},
			isStrictDevHost: () => {
				const host = window.location.hostname.toLowerCase();
				return host === 'dev.pos.karlstechnology.com'
					|| host === 'dev.pos.tacticalpay.com'
					|| host === 'dev.eposcloud.net'
					|| host === 'dev.pos.ammoready.com'
					|| host === 'dev.tacticalpos.com';
			},
		adminURL: () => {
			return window.location.hostname === 'beta.pos.karlstechnology.com' ?
				"https://beta.admin.pos.karlstechnology.com" :
				( window.location.hostname === 'pos.karlstechnology.com' ?
					'https://admin.pos.karlstechnology.com' :
					'https://dev.admin.pos.karlstechnology.com:4443' );
		},
		apiURL: () => {
			if(isPOS) {
				return window.location.hostname === 'beta.pos.karlstechnology.com' ? "https://beta.api.pos.karlstechnology.com" : (
					window.location.hostname === 'dev.pos.karlstechnology.com' ?
						'https://dev.api.pos.karlstechnology.com' :
						'https://api.pos.karlstechnology.com')
					;
			} else if (isTactical){
				return window.location.hostname === 'beta.tacticalpos.com' ? "https://beta.api.pos.tacticalpos.com" : (
					window.location.hostname === 'dev.tacticalpos.com' ?
						'https://dev.api.pos.tacticalpos.com' :
						'https://api.pos.tacticalpos.com')
					;
			} else if (isFFLBoss){
				return window.location.hostname === 'beta.pos.fflboss.com' ? "https://beta.api.pos.fflboss.com" : (
					window.location.hostname === 'dev.pos.fflboss.com' ?
						'https://dev.api.pos.fflboss.com' :
						'https://api.pos.fflboss.com')
					;
			} else if (isePOS){
				return window.location.hostname === 'beta.pos.eposcloud.net' ? "https://beta.api.pos.eposcloud.net" : (
					window.location.hostname === 'dev.pos.eposcloud.net' ?
						'https://dev.api.pos.eposcloud.net' :
						'https://api.pos.eposcloud.net')
					;
			} else if (isTacticalPay){
				return window.location.hostname === 'dev.pos.tacticalpay.com' ? 'https://dev.api.pos.tacticalpay.com' : (window.location.hostname === 'beta.pos.tacticalpay.com' ? "https://beta.api.pos.tacticalpay.com" : 'https://api.pos.tacticalpay.com');
			} else if (isAmmoReady){
				return window.location.hostname === 'dev.pos.ammoready.com' ? 'https://dev.api.pos.ammoready.com' : (window.location.hostname === 'beta.pos.ammoready.com' ? "https://beta.api.pos.ammoready.com" : 'https://api.pos.ammoready.com');
			}
		},
		fflBossURL: () => {
			if(isPOS) {
				return window.location.hostname === 'beta.pos.karlstechnology.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.karlstechnology.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isTactical){
				return window.location.hostname === 'beta.tacticalpos.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.tacticalpos.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isePOS){
				return window.location.hostname === 'beta.eposcloud.net' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.eposcloud.net' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isFFLBoss){
				return window.location.hostname === 'beta.pos.fflboss.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.fflboss.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isTacticalPay){
				return window.location.hostname === 'beta.pos.tacticalpay.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.tacticalpay.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			} else if (isAmmoReady){
				return window.location.hostname === 'beta.pos.ammoready.com' ?
					"https://beta.fflboss.com" :
					(window.location.hostname === 'pos.ammoready.com' ?
						'https://app.fflboss.com' :
						'https://dev.fflboss.com');
			}
		},
		apiVersion: 'v432'
	}
};

export default APPCONFIG;
